export const joinVerification = {
  'join-verification.title': 'Please verify your email address',
  'join-verification.subtitle':
    'We’ve sent an email to {email}. Click the link or enter the code below in the next two hours to create your account.',
  'join-verification.dont-see-an-email': 'Don’t see an email?',
  'join-verification.having-trouble': 'Having trouble? Contact us at ',
  'join-verification.welcome': 'Welcome to the sweetgreen family, {firstName}.',
  'resend-verification-code.success':
    'If your code is still active, we’ve sent an email to {email}. You have another two hours to verify.',

  // ─── Join Verification Errors ────────────────────────────────────────

  'join-verification.generic.failure':
    'Something went wrong, try again in a few moments...',
  'join-verification.code.failure': 'Invalid or expired confirmation code.',
  'join-verification.failed-to-fetch-customer-error':
    'We created your account, but are having issues logging you in. Please try logging in later.',
};
